import React__default, { useRef, useEffect } from 'react';
import { PropTypes } from 'prop-types';
import { s as setDomAttributes } from './utilsHelpers-21a239d9.js';
import { h as handleOpenLink } from './handleOpenLink-49ba3691.js';
import { n as nodeOrStringProp, d as domAttributesShape } from './PropTypes-9aad034b.js';
import './Icon.js';
import './_commonjsHelpers-97e6d7b1.js';
import 'moment';

function NewTabLink(props) {
  var children = props.children,
    content = props.content,
    href = props.href,
    className = props.className,
    onClick = props.onClick,
    domAttributes = props.domAttributes,
    newTabDisabled = props.newTabDisabled,
    openExternalLink = props.openExternalLink;
  var ref = useRef(null);
  useEffect(function () {
    setDomAttributes(ref, domAttributes);
  }, [domAttributes, ref]);
  function handleOnClick(e) {
    if (openExternalLink) {
      openExternalLink();
    } else {
      onClick(e);
      handleOpenLink(href, newTabDisabled);
    }
    if (ref.current) {
      ref.current.children[0].blur();
    }
  }
  return /*#__PURE__*/React__default.createElement("span", {
    onClick: handleOnClick,
    className: "bf-new-tab-link bf-cursor-pointer ".concat(className),
    ref: ref
  }, children || content);
}
NewTabLink.defaultProps = {
  children: '',
  content: '',
  href: '',
  onClick: function onClick() {},
  className: '',
  domAttributes: [],
  newTabDisabled: false,
  openExternalLink: null
};
NewTabLink.propTypes = {
  /**
  NewTabLink content
   */
  children: nodeOrStringProp,
  /**
  NewTabLink content
   */
  content: nodeOrStringProp,
  /**
  Link url
   */
  href: PropTypes.string,
  /**
  Function triggered on NewTabLink click
   */
  onClick: PropTypes.func,
  /**
  Custom className
   */
  className: PropTypes.string,
  /**
   * The new tab functionality may be disabled
   */
  newTabDisabled: PropTypes.bool,
  /**
   * If newTabDisabled, an external open function can be passed
   */
  openExternalLink: PropTypes.func,
  /**
  DOM attributes
   */
  domAttributes: PropTypes.arrayOf(PropTypes.shape(domAttributesShape))
};

export default NewTabLink;
